import { render, staticRenderFns } from "./TheShare.vue?vue&type=template&id=c8d5f81e&scoped=true"
import script from "./TheShare.vue?vue&type=script&lang=js"
export * from "./TheShare.vue?vue&type=script&lang=js"
import style0 from "./TheShare.vue?vue&type=style&index=0&id=c8d5f81e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d5f81e",
  null
  
)

export default component.exports